import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function DownloadBrowserIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Intersect" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M11.26 11.497c0.9573 -0.4577 1.6574 -1.391 1.7802 -2.479 0.2021 -1.88441 0.2019 -3.65259 0 -5.537 -0.1616 -1.43125 -1.3222 -2.5948 -2.753 -2.760003 -2.2118 -0.243918 -4.36234 -0.247269 -6.574 0.001C2.28237 0.8872 1.12177 2.05075 0.960201 3.482c-0.202238 1.88401 -0.202048 3.65199 0 5.536 0.122819 1.088 0.822949 2.0213 1.780239 2.479"
          strokeWidth="1"></path>
    <path id="Intersect_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m13.0684 3.75 -12.136759 0c0.009259 -0.08971 0.018689 -0.17922 0.028245 -0.26853C1.11402 2.04082 2.27272 0.882112 3.71267 0.721609 4.78222 0.602392 5.88039 0.5 7.00002 0.5s2.21779 0.102392 3.28738 0.221609c1.4399 0.160503 2.5986 1.319211 2.7528 2.759861 0.0095 0.08931 0.0189 0.17882 0.0282 0.26853Z"
          strokeWidth="1"></path>
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round" d="M7 7.12112 7 13.5"
          strokeWidth="1"></path>
    <path id="Vector_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M9.02344 11.4764c-0.40473 0.8094 -1.21419 1.6189 -2.02362 2.0236 -0.80949 -0.4047 -1.61895 -1.2142 -2.02368 -2.0236"
          strokeWidth="1"></path>
  </SvgIcon>
}
